class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    const title = this.querySelector('.collapsible__title');
    const content = this.querySelector('.collapsible__content');

    // Ensure both elements exist
    if (!title || !content) {
      console.error('CollapsibleElement: Missing title or content elements.');
      return;
    }

    // Function to update height dynamically
    const updateHeight = () => {
      if (title.getAttribute('active') === 'true') {
        content.style.height = `${content.scrollHeight}px`; // Expand to full content height
      } else {
        content.style.height = '0px'; // Collapse
      }
    };

    // Initialize state
    if (title.getAttribute('active') === 'true') {
      title.setAttribute('aria-expanded', 'true');
      content.setAttribute('active', 'true');
      content.style.height = `${content.scrollHeight}px`;
    } else {
      title.setAttribute('active', 'false');
      title.setAttribute('aria-expanded', 'false');
      content.style.height = '0px';
    }

    // Click event for toggling
    title.addEventListener('click', (e) => {
      e.preventDefault();
      const isActive = title.getAttribute('active') === 'true';
      title.setAttribute('active', isActive ? 'false' : 'true');
      title.setAttribute('aria-expanded', !isActive);
      content.setAttribute('active', !isActive);
      updateHeight();

      if (title.classList.contains('read-more-link')) {
        title.innerHTML = isActive ? title.dataset.readMore : title.dataset.readLess;
      }
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (title.getAttribute('active') === 'true') {
        content.style.height = `${content.scrollHeight}px`; // Recalculate height
      }
    });
  }
}

customElements.define('collapsible-element', CollapsibleElement);
